define(function(require){
    /**
	 * Получение таймштампа из даты
	 * @param  {[string]} date_string - дата в формате 'dd.mm.yyyy hh:mm:ss'
	 * @return {[int]}
	 */
    return function getTimestamp(date_string){
        
    	date_string = date_string.split(' ');

    	var date = date_string[0].split('.');
    	var time = date_string[1].split(':');

        /**
         * Проверка, если в функцию не были переданы секунды
         */
        if(time[2] == null || typeof(time[2]) == 'undefined' ) time[2] = '00';
        
         //var datum = new Date( Date.UTC(parseInt(date[2]), parseInt(date[1]-1), parseInt(date[0]), parseInt(time[0]), parseInt(time[1]), parseInt(time[2])) ).toGMTString();
        
        //var datum = Date.UTC(parseInt(date[2]), parseInt(date[1]-1), parseInt(date[0]), (parseInt(time[0]) + 3), parseInt(time[1]), parseInt(time[2]));
        var datum = new Date(parseInt(date[2]), parseInt(date[1]-1), parseInt(date[0]), (parseInt(time[0])), parseInt(time[1]), parseInt(time[2]));

        // console.log('DATUM', datum);

        // var timestamp = moment.tz(datum, "Europe/Moscow");
        
        // var timestamp = moment.tz(date + ' ' + time, "Europe/Moscow");

        // console.log('TIMESTAMP', moment.unix(timestamp));

        
        return Math.round( datum / 1000 );
    }
});

